/*
 * Send event to dataLayer
 */
import LocalStorageService from '../../../Storage/LocalStorageService';

const sendEventTracking = (
  params: {
    event: string;
    dataLayer: any;
    ecommerce: any;
  },
  addToLocalStorage = false
) => {
  const formatData = {
    event: params.event,
    ecommerce: params.ecommerce,
  };

  if (addToLocalStorage) {
    const serviceStorage = new LocalStorageService();
    const dataLayerLocalStorage: any =
      serviceStorage.getItem('dataLayer') || [];
    dataLayerLocalStorage.push(formatData);
    serviceStorage.setItem('dataLayer', dataLayerLocalStorage);
  } else {
    params.dataLayer.push({ ecommerce: null });
    params.dataLayer.push(formatData);
  }
};

export default sendEventTracking;
